import React, { FC } from 'react'
import RepPerformanceContainer from 'containers/RepPerformance'

const RepPerformancePage: FC = () => <RepPerformanceContainer />

export default RepPerformancePage
